import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Divider, Drawer, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import Tabs from '../common/Tabs';
import { TableHeader } from '../common/TableToolbar';
import Paper from '../common/layout/Paper';
import ExternalCrew from './ExternalCrew';
import Groups from './Groups';
import InternalCrew from './InternalCrew';
import ClientsTable from '../clients/ClientsTable';

export default function CrewScreen() {
	const location = useLocation();
	const theme = useTheme();

	const basePath = '/crew';
	const panels = [
		{
			label: 'Clients',
			component: <ClientsTable />,
			href: `${basePath}/clients`,
			key: `${basePath}/clients`,
		},
		{
			label: 'Staff',
			component: <InternalCrew />,
			href: `${basePath}/internal`,
			key: `${basePath}/internal`,
		},
		{
			label: 'Crew',
			component: <ExternalCrew />,
			href: `${basePath}/external`,
			key: `${basePath}/external`,
		},
		{
			label: 'Groups',
			component: <Groups />,
			href: `${basePath}/groups`,
			key: `${basePath}/groups`,
		},
	];

	return (
		<>
			<Container gradientBorder>
				<Box
					sx={{
						width: '100%',
						backgroundColor: theme.palette.background.paper,
						borderRadius: 2,
						position: 'relative',
						flex: 1,
						overflow: 'auto',
						height: 'calc(100vh - 98px)',
						padding: 1,
					}}
				>
					<TableHeader>People</TableHeader>
					<Tabs panels={panels} currentPath={location.pathname} />
				</Box>
			</Container>
		</>
	);
}

const PageWrapper = styled.div`
	display: flex;
	width: 100%;
	position: relative;
`;

const Container = styled(Paper)<{ $drawerOpen?: boolean }>`
	flex: 1;
	transition: width 0.3s ease-out;
	width: ${(props) => (props.$drawerOpen ? 'calc(100% - 360px)' : '100%')};
	margin-right: ${(props) => (props.$drawerOpen ? '348px' : '0')};
`;

const DescriptionText = styled.div`
	color: ${(props) => props.theme.palette.text.secondary};
`;

const TemplateName = styled.div`
	font-size: 16px;
	max-width: 80%;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const FileDetails = styled.div`
	font-size: 16px;
	font-weight: 500;
`;

const StyledDivider = styled(Divider)`
	margin: 16px -16px !important;
`;

const StyledCloseButton = styled(IconButton)`
	position: absolute !important;
	top: 8px;
	right: 8px;
`;

const DrawerContainer = styled(Paper)`
	background-color: ${(props) => props.theme.palette.background.paper};
	padding: 6px;
	width: 335px;
	margin-top: 80px;
	border-radius: 8px;
	position: relative;
	font-size: 14px;
`;

const DetailsContainer = styled.div`
	margin-top: 16px;
`;

const DetailItem = styled.div`
	margin-bottom: 8px;
`;

const DetailValue = styled.div`
	margin-left: 8px;
	color: ${(props) => props.theme.palette.text.secondary};
`;

const NameIconContainer = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 16px;
`;
